import React from "react"

import { AlternativeLoginForPassword } from "./AlternativeLogin"
import { LoginWithCirrusPlatformForm } from "./Form"
import { useCustomerInfo } from "../../../CustomerInfo"

export const LoginWithPasswordScreenContent = () => {
  const { data } = useCustomerInfo()
  const showAlternativeLogin = !!data?.keycode || data?.saml?.enabled

  return <>
    <LoginWithCirrusPlatformForm/>

    {showAlternativeLogin && <AlternativeLoginForPassword/>}
  </>
}
